var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElma365Line(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8584 9.40893V12L22 8.86485C21.8617 7.00055 21.0226 5.25726 19.6509 3.98423C18.2791 2.71119 16.476 2.00246 14.6027 2H12V5.15408H14.6027C15.7343 5.15408 16.8196 5.60268 17.6198 6.40121C18.4199 7.19975 18.8695 8.28279 18.8695 9.41208",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 18.8579H12L15.1327 22C16.9977 21.8634 18.7422 21.0243 20.0161 19.6512C21.2898 18.278 21.9986 16.4724 22 14.5968V12H18.8484V14.5968C18.8484 15.7286 18.4001 16.814 17.6022 17.6143C16.8043 18.4146 15.7222 18.8642 14.5938 18.8642",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14318 14.5911V12L2 15.1351C2.13838 17.0005 2.97836 18.7447 4.35147 20.0178C5.72457 21.2911 7.52928 21.9991 9.4036 22H12V18.8459H9.4036C8.272 18.8459 7.18672 18.3973 6.38656 17.5987C5.58639 16.8002 5.13685 15.7172 5.13685 14.5879",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40893 5.13843H12L8.86485 2C6.99948 2.13838 5.25528 2.97836 3.98208 4.35147C2.7089 5.72457 2.00086 7.52928 2 9.4036V12H5.15408V9.40044C5.15408 8.26882 5.6027 7.18357 6.40121 6.38339C7.19975 5.58322 8.28279 5.13369 9.41208 5.13369",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElma365Line);
export default __webpack_public_path__ + "clientapp/media/elma365_line.afe1bcf7.svg";
export { ForwardRef as ReactComponent };